module.exports = __webpack_public_path__ + "media/complete_exercise.e10fb2df.mp3";